import { client } from "@/client";
import { useEffect, useState } from "react";
import { FetchTenderByIdDocument, Tender } from "../../graphql/__generated__/graphql";

export function useWatchTenderById(tenderId: number) {
  const [data, setData] = useState<Tender | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const observable = client.watchQuery({
      query: FetchTenderByIdDocument,
      variables: { id: tenderId },
      fetchPolicy: "cache-only"
    });

    const subscription = observable.subscribe({
      next: ({ data }) => {
        setData(data?.fetchTenderById as Tender | null);
        setLoading(false);
      },
      error: (err) => {
        setError(err);
        setLoading(false);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [client, tenderId]);

  return { data, loading, error, refetch: () => client.refetchQueries({ include: [FetchTenderByIdDocument] }) };
}
